import { Directive, Input } from '@angular/core';
import { CellData } from '@shared/interfaces/table/cell-data';

@Directive()
export abstract class CellRenderer {
  /**
   * Configuration parameters passed through the table column configuration.
   * @property {string} key - The field name containing the value
   * @property {Object} cellRendererParams - Additional configuration options for the cell renderer
   * @property {string} cellRendererParams.format - The date format pattern to be used (e.g., 'yyyy-dd-MM', 'dd/MM/yyyy')
   * @property {string} cellRendererParams.url - Base URL for a link
   * @property {string} cellRendererParams.urlReference - Optional field name whose value will be appended to the URL
   */
  @Input() public params: { cellRendererParams?: any, [key: string]: any } = {};

  /**
   * Data object containing the cell's value and any additional metadata.
   * Automatically populated by the table component based on the row data.
   */
  @Input() public data: CellData = {};

  /**
   * The processed value that is set during initialization after normalization and mapping.
   * Can be used as an alternative to passing the value through data.
   */
  @Input() public value?: string;
}
